import React from "react";
import ArticleListItem from "../components/article-list-item";
import Layout from "../components/layout";
import PageSectionHeading from "../components/common/page-section-heading";
import SEO from "../components/seo";
const GrohPage = _ref => {
    let { data } = _ref;
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(SEO, {
        title: "Die zentralen Themen, Thesen und Irrt\xFCmer der Wirtschaftstheorien"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap justify-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full border-t-8 border-solid border-makroOrange"
    }, /*#__PURE__*/ React.createElement(PageSectionHeading, {
        className: "mb-4",
        title: "Guide f\xFCr Einsteiger"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "w-full px-3 mb-10 lg:pl-8 lg:w-2/3 lg:pr-4"
    }, /*#__PURE__*/ React.createElement("h1", {
        className: "text-makroOrange text-3xl md:text-4xl mb-5"
    }, "Die zentralen Themen, Thesen und Irrt\xFCmer der Wirtschaftstheorien"), /*#__PURE__*/ React.createElement("p", {
        className: "text-lg"
    }, "Wirtschaftswissenschaft ist f\xFCr Sie Neuland, das Sie betreten m\xF6chten? Dann lassen Sie sich wie Lukas von Jakob auf eine spannende Reise durch die zentralen Themen, Thesen und Irrt\xFCmer unserer Wirtschaftstheorien mitnehmen.")), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-row flex-wrap"
    }, data.allDatoCmsArticle.nodes.map((article, index) => {
        var _article$image;
        return /*#__PURE__*/ React.createElement(ArticleListItem, {
            key: article.id,
            articleId: article.id,
            authors: article.authors,
            excerpt: article.excerpt,
            to: `/${article.slug}/`,
            title: article.title,
            image: (_article$image = article.image) === null || _article$image === void 0 ? void 0 : _article$image.fluid,
            smallTitle: article.smallTitle,
            index: index,
            authorLinks: false,
            visibility: article.visibility
        });
    })))));
};
const query = "4285474741";
export default GrohPage;
